"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const coursesDetails = {
  ausatmen: {
    title: "Den Tag ausatmen: Deine Abendroutine mit Yoga & Qi Gong - Präventionskurs",
    time: "Mittwochs, 18:00 - 19:00 Uhr",
    duration: "8 Abende",
    date: "23.09.2026 bis 18.11.2026",
    freetime: "Am 11.11.2026 findet kein Kurs statt.",
    price: "110,00 € (Krankenkassen-Zuschuss möglich)",
    description: "Wir kennen alle die Idee der Morgenroutine, um fit in den Tag zu starten. Doch wie beenden wir ihn? Gerade Frauen neigen oft dazu, den Tag bis zur allerletzten Minute produktiv auszunutzen, um Haushalt, Familie oder die beruflichen Pflichten komplett zu erledigen. Wenn wir uns so direkt ins Bett legen, laufen Körper und Geist noch lange auf Hochtouren. Der Organismus ist voller Stresshormone, das Gehirn arbeitet in der Verarbeitungsschleife weiter und wir finden keinen erholsamen Schlaf. Die Quittung: Der Schlaf dient nur noch der Stressverarbeitung statt der echten Regeneration. Dieser 8-wöchige Kurs lädt Sie ein, eine bewusste Abendroutine zu entwickeln und den Tag ganz bewusst „auszuatmen“: Basierend auf traditionellen fernöstlichen Routinen und moderner Psychologie schaffen wir eine wirksame Erholungsinsel für die Wochenmitte. Mit weichen, fließenden Bewegungen aus dem Yoga und Qi Gong lösen wir körperliche Enge und Verspannungen. Dazu erlernen Sie effektive geistige und körperliche Techniken, um das Gedankenkarussell herunterzufahren und Unerledigtes für die Nacht „schlafen zu legen“. Ein klarer, heilsamer Übergang vom Tun ins Sein – damit Sie mit einem freien Kopf beruhigt in eine gute Nacht gehen und am nächsten Morgen mit echter Energie erwachen.",
    content: ["Die Biologie des Runterfahrens: Verstehen, wie chronische Aktivität bis zur letzten Minute das Nervensystem in der Stressschleife hält und wie ein bewusster Übergang biologisch wirkt.", "Körperliches Entladen: Sanfte, fließende Bewegungen aus dem Qi Gong und regenerativen Yoga, um muskuläre Anspannung und aufgestaute Stresshormone sanft abzubauen.", "Mentale Klärung (Unerledigtes schlafen legen): Gezielte geistige und meditative Techniken, um offene To-do-Listen und die Dynamik des Tages innerlich „zu den Akten zu legen“.", "Nervliche Selbstregulation: Kombinierte Atem- und Spürübungen zur gezielten Aktivierung des Parasympathikus (Ruhenerv) für eine messbar höhere Schlafqualität."],
    materials: "Schreibzeug, ein persönlicher Notizblock, bequeme Kleidung, dicke Socken und eventuell Hausschuhe. Die Räumlichkeiten sowie die erforderliche Ausstattung (Matten, Meditationskissen, Decken) werden vollständig bereitgestellt."
  },
  taichi: {
    title: "Tai Chi 24 Yang-Stil (Peking-Form) – Fortgeschrittene",
    time: "Donnerstags, 19:15 - 20:30 Uhr",
    duration: "8 Abende",
    date: "08.10.2026 bis 26.11.2026",
    freetime: "",
    price: "120,00 €",
    description: "Tai Ji Quan, oft auch als Schattenboxen bezeichnet, ist eine jahrhundertealte chinesische Bewegungskunst, die Ästhetik, Selbstverteidigung und Gesundheitsfürsorge harmonisch verbindet. Sie zeichnet sich durch weiche, weiträumige und gleichmäßig fließende Bewegungen aus, die wie ein ruhiger Fluss ineinandergreifen. Das bewusste, langsame Ausführen der Formen schult das Gleichgewicht, stärkt die Gelenke und korrigiert sanft Haltungsfehler. Es ist zudem Meditation in Bewegung und schult Körperwahrnehmung, Konzentration und Achtsamkeit. Dieser Kurs richtet sich an alle, die bereits Vorerfahrung im 24er Yang-Stil Tai Ji („Peking-Form“) haben. Wir wiederholen Teil 1 und 2 der Form und erlernen bzw. vertiefen die komplexeren Teile 3 und 4. Anwendungen und gesundheitliche Bedeutungen der einzelnen Figuren werden erläutert.",
    content: ["Gelenkschonendes Aufwärmen, Dehnen und vorbereitende Basisübungen.", "Wiederholung und Vertiefung von Teil 1 und 2 der 24er Yang-Form.", "Detaillierte, bildhafte Vermittlung die Figuren von Teil 3 und 4.", "Gemeinsames Durchlaufen der gelernten Sequenzen im Fluss zur Verankerung des Bewegungsmusters und Hinweise zum Üben im Alltag.", "Hintergrundwissen zu Anwendung und gesundheitlicher Wirkung der Figuren sowie weiterführende Tipps zur Gesundheitspflege aus der Traditionellen Chinesischen Medizin (TCM)."],
    materials: "Saubere, rutschfeste Indoor-Schuhe mit flacher, heller Sohle (kein Training in Socken, Stoppersocken oder Schlappen), bequeme Kleidung. Das eigene Smartphone kann mitgebracht werden, um die Bewegungssequenz für das spätere Üben zu filmen."
  }
};
export default function WeeklyCourses() {
  const [activeCourse, setActiveCourse] = React.useState(null);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const daysData = [{
    day: "Mittwoch",
    courses: [{
      key: "ausatmen",
      label: "Den Tag ausatmen: Deine Abendroutine mit Yoga & Qi Gong",
      time: "18:00 - 19:00 Uhr"
    }]
  }, {
    day: "Donnerstag",
    courses: [{
      key: "taichi",
      label: "Tai Chi Yang Stil 24 (Fortgeschrittene)",
      time: "19:15 - 20:30 Uhr"
    }]
  }];
  const openModal = courseKey => {
    if (courseKey && coursesDetails[courseKey]) {
      setActiveCourse(coursesDetails[courseKey]);
    }
  };
  const closeModal = () => {
    setActiveCourse(null);
  };
  return <section id="wochenplan" className="bg-background py-16 md:py-24 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-8 max-w-5xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Wöchentliche Kurse
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Finde die Balance in deinem Alltag: Wöchentliches Training mit Gleichgesinnten, intensives Wochenendseminar zum tiefen Eintauchen oder Einzelunterricht nach Maß - hier findest du dein Format. Viele Kurse und Wochenendseminare werden von den Krankenkassen bezuschusst. Klicke auf einen Kurs für alle Beschreibungen und Termine.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {daysData.map((dayGroup, idx) => <div key={idx} className="flex flex-col bg-muted/20 border border-border rounded-xl p-5 shadow-sm">
              <h3 className="text-xl font-bold text-primary border-b border-border pb-3 mb-4 text-center">
                {dayGroup.day}
              </h3>
              <div className="flex-1 space-y-4">
                {dayGroup.courses.map((course, cIdx) => <button key={cIdx} onClick={() => openModal(course.key)} className="w-full text-left bg-background border border-border rounded-lg p-4 shadow-sm hover:border-primary hover:shadow-md transition-all group focus:outline-none">
                    <div className="font-semibold text-foreground group-hover:text-primary transition-colors text-base">
                      {course.label}
                    </div>
                    <div className="text-sm text-muted-foreground mt-1.5 flex items-center">
                      <span className="w-2 h-2 rounded-full bg-primary/60 mr-2"></span>
                      {course.time}
                    </div>
                  </button>)}
              </div>
            </div>)}
        </div>
      </div>

      {/* Pop-up Fenster (Modal) */}
      {activeCourse && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={closeModal}>
          <div className="bg-background border border-border rounded-xl max-w-2xl w-full max-h-[85vh] overflow-y-auto shadow-xl p-6 relative animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()}>
            <button onClick={closeModal} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground text-2xl font-semibold focus:outline-none">
              &times;
            </button>

            <h3 className="text-2xl font-bold text-primary mb-2 pr-6">{activeCourse.title}</h3>
            <p className="text-sm text-muted-foreground mb-4 font-medium">
              {activeCourse.date} | {activeCourse.time} ({activeCourse.duration})
            </p>

            {activeCourse.freetime && <div className="bg-destructive/10 text-destructive text-xs font-semibold rounded-md p-2.5 mb-4 border border-destructive/20">
                Hinweis: {activeCourse.freetime}
              </div>}

            <div className="mb-4 text-sm leading-relaxed text-muted-foreground">
              {activeCourse.description}
            </div>

            <div className="mb-6">
              <h4 className="font-bold text-foreground mb-2 text-sm">Kursinhalte:</h4>
              <ul className="list-disc pl-5 space-y-1.5 text-muted-foreground text-sm">
                {activeCourse.content.map((bullet, idx) => <li key={idx}>{bullet}</li>)}
              </ul>
            </div>

            <div className="mb-4 text-sm">
              <span className="font-bold text-foreground">Mitzubringen:</span>{" "}
              <span className="text-muted-foreground">{activeCourse.materials}</span>
            </div>

            <div className="mb-6 bg-muted/40 p-3 rounded-lg border border-border text-sm text-muted-foreground">
              In Kooperation mit der VHS Naheland. Die Anmeldung ist direkt über die{" "}
              <a href="https://vhs-naheland.de/Suche?cmxelementid=web4e15b88472a73&seite=&Suche=1&Suchbegriffe=Claudia+Christ&Vormittag=1&Nachmittag=1&Abend=1&Montag=1&Dienstag=1&Mittwoch=1&Donnerstag=1&Freitag=1&Samstag=1&Sonntag=1" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80 font-medium">
                Volkshochschule Naheland
              </a>{" "}
              möglich.
            </div>

            <div className="border-t border-border pt-4 flex items-center justify-between mt-6">
              <div>
                <span className="text-xs uppercase tracking-wider text-muted-foreground block font-semibold">
                  Investition
                </span>
                <span className="text-lg font-bold text-foreground">{activeCourse.price}</span>
              </div>
              <button onClick={closeModal} className="bg-primary text-primary-foreground hover:bg-primary/90 px-5 py-2 rounded-lg font-medium text-sm shadow-sm transition-colors">
                Schließen
              </button>
            </div>
          </div>
        </div>}
    </section>;
}